import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTheme } from "@mui/material";

import { getTabData, slugify } from "gatsby-frontend";
import { Blocks } from "./../../";

function Tab(entity) {
	const { title } = entity.attributes;
	const tab_data = getTabData(entity);
	const theme = useTheme();
	const tab_color = theme.palette.tab
		? theme.palette.tab
		: {
				main: theme.palette.grey["200"],
				contrastText: theme.palette.grey["900"],
		  };
	return (
		<Accordion
			sx={{ backgroundColor: theme.palette.grey["200"] }}
			id={slugify(title)}
		>
			<AccordionSummary
				expandIcon={<ExpandMoreIcon />}
				aria-controls={`${entity.id}-content`}
				id={`${entity.id}-header`}
				sx={{ backgroundColor: tab_color.main, color: tab_color.contrastText }}
			>
				<Typography>{title}</Typography>
			</AccordionSummary>
			<AccordionDetails>
				<Blocks data={tab_data} className="tab-section" />
			</AccordionDetails>
		</Accordion>
	);
}

export default Tab;
